import {
  Header,
  Hero,
  WhatWeDo,
  HowItWorks,
  Tryouts,
  Academies,
  ClubTalentstar,
  SoccerCollege,
  Stats,
  SuccessStories,
  PressQuotes,
  Partners,
  Pricing,
  DownloadCTA,
  Footer,
  DeleteAccount,
  Policies,
} from './components/sections';
import { GlobalBackground } from './components/3d/GlobalBackground';
import { VideoPlayer } from './components/ui/VideoPlayer';
import { TryoutPopup } from './components/ui/TryoutPopup';
import { VideoModeProvider } from './context';
import { BecasWizard } from './components/becas/BecasWizard';
import { BECAS_WIZARD_PATHS } from './constants/becas';

const DELETE_ACCOUNT_PATHS = ['/eliminar-data', '/eliminar-datos', '/delete-account'];
const POLICIES_PATHS = ['/politicas', '/politica', '/policies', '/privacy', '/terms'];

function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';

  if (DELETE_ACCOUNT_PATHS.includes(path)) {
    return <DeleteAccount />;
  }

  if (POLICIES_PATHS.includes(path)) {
    return <Policies />;
  }

  if ((BECAS_WIZARD_PATHS as readonly string[]).includes(path)) {
    return <BecasWizard />;
  }

  return (
    <VideoModeProvider>
      <div className="min-h-screen bg-brand-darkNavy relative">
        {/* Global 3D Background */}
        <GlobalBackground />
        
        {/* Video Player Overlay */}
        <VideoPlayer />

        <TryoutPopup />

        {/* Content */}
        <div className="relative z-10">
          <Header />
          <main>
            <Hero />
            <WhatWeDo />
            <HowItWorks />
            <Tryouts />
            <Academies />
            <ClubTalentstar />
            <SoccerCollege />
            <Stats />
            <SuccessStories />
            <PressQuotes />
            <Partners />
            <Pricing />
            <DownloadCTA />
          </main>
          <Footer />
        </div>
      </div>
    </VideoModeProvider>
  );
}

export default App;
